import { render, staticRenderFns } from "./matrixTypePC.vue?vue&type=template&id=38c234f6&scoped=true&"
import script from "./matrixTypePC.vue?vue&type=script&lang=js&"
export * from "./matrixTypePC.vue?vue&type=script&lang=js&"
import style0 from "./matrixTypePC.vue?vue&type=style&index=0&id=38c234f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c234f6",
  null
  
)

export default component.exports